import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=71043814&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "./detail.vue?vue&type=style&index=0&id=71043814&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71043814",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71043814')) {
      api.createRecord('71043814', component.options)
    } else {
      api.reload('71043814', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=71043814&scoped=true", function () {
      api.rerender('71043814', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/sfa/views/order_manage/deeply_cultivate_data/form/detail.vue"
export default component.exports